import { createContext, useState } from "react";

export const MapContext = createContext()

export default function MapContextApi({ children }) {
    const [filters, setFilters] = useState({
        crop: "",
        infestation_id: null,
        state: null,
        district: null,
        sub_district: null,
        villages: null,
        crop_options: [],
        infest_options: [],
        state_options: [],
        district_options: [],
        sub_district_options: [],
        villages_options: [],
        lat: 22.150535,
        lon: 81.556363,
        zoom: 4,
    });

    const [sowingDate, setSowingDate] = useState('')
    const [analysis, setAnalysis] = useState('Infestation Comparison (2 weeks)')
    const [geojsonData, setGeojsonData] = useState(null)
    return (
        <MapContext.Provider value={{
            filters,
            setFilters,
            analysis,
            setAnalysis,
            sowingDate,
            setSowingDate, 
            geojsonData,
            setGeojsonData
        }}>{children}</MapContext.Provider>
    )
}